var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99989 6.55642C7.6168 6.55642 7.2494 6.70861 6.97851 6.97949C6.70763 7.25038 6.55545 7.61778 6.55545 8.00087C6.55545 8.38396 6.70763 8.75136 6.97851 9.02224C7.2494 9.29313 7.6168 9.44531 7.99989 9.44531C8.38298 9.44531 8.75038 9.29313 9.02127 9.02224C9.29215 8.75136 9.44434 8.38396 9.44434 8.00087C9.44434 7.61778 9.29215 7.25038 9.02127 6.97949C8.75038 6.70861 8.38298 6.55642 7.99989 6.55642ZM6.19284 6.19382C6.6721 5.71456 7.32212 5.44531 7.99989 5.44531C8.67767 5.44531 9.32768 5.71456 9.80694 6.19382C10.2862 6.67308 10.5554 7.32309 10.5554 8.00087C10.5554 8.67864 10.2862 9.32866 9.80694 9.80792C9.32768 10.2872 8.67767 10.5564 7.99989 10.5564C7.32212 10.5564 6.6721 10.2872 6.19284 9.80792C5.71358 9.32866 5.44434 8.67864 5.44434 8.00087C5.44434 7.32309 5.71358 6.67308 6.19284 6.19382Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.22352 7.99957C3.05187 10.3929 5.32638 12.1107 7.9999 12.1107C10.674 12.1107 12.9479 10.3929 13.7763 7.99957C12.9479 5.60621 10.674 3.88845 7.9999 3.88845C5.32638 3.88845 3.05187 5.60624 2.22352 7.99957ZM1.10853 7.83312C2.0285 4.90351 4.76566 2.77734 7.9999 2.77734C11.2348 2.77734 13.9713 4.90355 14.8913 7.83312C14.9253 7.94148 14.9253 8.05766 14.8913 8.16601C13.9713 11.0956 11.2348 13.2218 7.9999 13.2218C4.76566 13.2218 2.0285 11.0956 1.10853 8.16601C1.0745 8.05766 1.0745 7.94148 1.10853 7.83312Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg15);
export default __webpack_public_path__ + "static/media/svg15.da55d7ba9df71403d5f2aaff36ead641.svg";
export { ForwardRef as ReactComponent };